import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-usage-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="bar-wrap">
      <div class="track">
        <div class="fill" [style.width.%]="pct" [style.background]="barColor"></div>
      </div>
      <span class="pct">{{ pct | number:'1.0-0' }}%</span>
    </div>
  `,
  styles: [`
    .bar-wrap { display: flex; align-items: center; gap: 10px; }
    .track {
      flex: 1; height: 7px; background: #21262d; border-radius: 4px; overflow: hidden;
    }
    .fill {
      height: 100%; border-radius: 4px; transition: width .5s ease;
    }
    .pct {
      font-family: 'JetBrains Mono', monospace; font-size: 12px;
      font-weight: 600; color: #8b949e; min-width: 36px;
    }
  `],
})
export class UsageBarComponent {
  @Input() value = 0;
  @Input() max = 0;

  get pct(): number {
    return this.max ? Math.min(100, (this.value / this.max) * 100) : 0;
  }

  get barColor(): string {
    if (this.pct > 90) return '#f85149';
    if (this.pct > 70) return '#f0883e';
    return '#00c1a3';
  }
}
